import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import useTrainingLesson from '@hooks/useTrainingLesson'

import type { TrainingLessonModel } from '@models/types'

type TrainingLessonListItemItemProps = {
  trainingLesson: TrainingLessonModel,
}

const TrainingLessonListItem = (props: TrainingLessonListItemItemProps) => {
  const { trainingLesson } = props

  const {
    callbacks: {
      deleteTrainingLesson: deleteFn,
    },
    urls: { editTrainingLessonUrl },
  } = useTrainingLesson(trainingLesson)

  const { title } = trainingLesson

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    strings: { entityName: 'Training Lesson' },
  }

  return (
    <DashboardModuleListItem
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editTrainingLessonUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default TrainingLessonListItem
